const OPEN_FILTER_MENU_KEY = "backoffice-participants-filter-menu-open"

const rememberOpenFilterMenu = (kind, id) => {
  sessionStorage.setItem(OPEN_FILTER_MENU_KEY, `${kind}:${id}`)
}

const openStatusFilterMenu = (root) => {
  const trigger = root.querySelector("[data-participants-status-filter-trigger]")
  const menu = root.querySelector("[data-participants-status-filter-menu]")
  const pill = root.querySelector(".backoffice-participants-inscription-filter__pill")
  if (!trigger || !menu) return

  menu.hidden = false
  trigger.setAttribute("aria-expanded", "true")
  trigger.classList.add("is-open")
  if (pill) pill.classList.add("is-open")
}

const openCatalogueFilterMenu = (root) => {
  const trigger = root.querySelector("[data-participants-catalogue-filter-trigger]")
  const menu = root.querySelector("[data-participants-catalogue-filter-menu]")
  const pill = root.querySelector(".backoffice-participants-catalogue-filter__pill")
  if (!trigger || !menu) return

  menu.hidden = false
  trigger.setAttribute("aria-expanded", "true")
  trigger.classList.add("is-open")
  if (pill) pill.classList.add("is-open")
}

const restoreOpenFilterMenu = () => {
  const token = sessionStorage.getItem(OPEN_FILTER_MENU_KEY)
  if (!token) return
  sessionStorage.removeItem(OPEN_FILTER_MENU_KEY)

  const separator = token.indexOf(":")
  if (separator === -1) return

  const kind = token.slice(0, separator)
  const id = token.slice(separator + 1)

  if (kind === "status") {
    document.querySelectorAll("[data-participants-status-filter]").forEach((root) => {
      if (root.dataset.participantsStatusParam === id) openStatusFilterMenu(root)
    })
  } else if (kind === "catalogue") {
    document.querySelectorAll("[data-participants-catalogue-filter]").forEach((root) => {
      openCatalogueFilterMenu(root)
    })
  }
}

export { rememberOpenFilterMenu, restoreOpenFilterMenu }
